<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            :clearable="clearable"
            :showAdd="showAdd"
        />
    </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    name: 'SysSelectHour',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
    }),
    created() {
        this.getItems();
    },
    props: {
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        showAll:{
            type: Boolean,
            default: true
        },
        maxShift: {
            type: Number,
            default: 3
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },
    },
    methods: {
        ...mapActions('hour', ['ActionGetHours']),
        
        async getItems() {

            this.loading = true

            await this.ActionGetHours()
                    .then((res) => {
                        
                        if(this.showAll){
                            this.items = res.data;
                        }else{
                            this.items = res.data.filter(s => s.id <= this.maxShift);
                        }
                        this.selected = this.model;
                        
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },
    },
    
}
</script>